var map = {
	"./Logos-06.png": 108,
	"./airbnbLogo.png": 109,
	"./asanbuy (1).png": 26,
	"./asanbuy.png": 110,
	"./begintech.jpg": 111,
	"./begintech.png": 112,
	"./cake craft.png": 113,
	"./cakecraft.png": 34,
	"./caplot.png": 28,
	"./codeInLogo.webp": 35,
	"./contactMail.webp": 114,
	"./contactMailDark.svg": 115,
	"./developerActivity.svg": 40,
	"./facebookLogo.png": 116,
	"./googleAssistant.svg": 117,
	"./googleAssistantLogo.webp": 36,
	"./harvardLogo.png": 118,
	"./jsFramework.svg": 119,
	"./manOnTable.svg": 39,
	"./mungalo.png": 32,
	"./nextuLogo.webp": 120,
	"./occi.png": 121,
	"./programmer.svg": 122,
	"./pwa.webp": 123,
	"./pwaLogo.webp": 37,
	"./quoraLogo.png": 124,
	"./rholab.png": 29,
	"./rholab1.jpg": 25,
	"./rholab1.png": 125,
	"./saayaHealthLogo.webp": 126,
	"./sheen.png": 33,
	"./skill.svg": 41,
	"./sonya batla.png": 30,
	"./ssuet.jpg": 24,
	"./stanfordLogo.png": 127,
	"./supreme.png": 31,
	"./talksCardBack.svg": 128,
	"./talksCardBackAlt.svg": 129,
	"./zarrar.png": 27
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 107;